import loadingStyles from "./LoadingGate.module.css";
import gateStyles from "./Gate.module.css";

interface Props {
  title: string;
  subtitle: React.ReactNode;
  dataCy?: string;
}

export function LoadingGate({ title, subtitle, dataCy }: Props) {
  return (
    <div className={gateStyles.entry}>
      <div className={gateStyles.panel} data-cy={dataCy}>
        <div
          className={loadingStyles.loadingWrap}
          aria-live="polite"
          aria-busy="true"
        >
          <div className={loadingStyles.loadingSpinner} />
          <h1 className={gateStyles.title}>{title}</h1>
          <p className={gateStyles.subtitle}>{subtitle}</p>
        </div>
      </div>
    </div>
  );
}
